import { useState } from "react";
import { decryptPayload } from "../../apis/crypto";
import { apiClient } from "../../apis/api-client";
import { API } from "../../Services/apimethod.js"
import {getTokenExp,decryptData} from "@/Services/req_res_decode_encode";
import toast from 'react-hot-toast';

export default function EligibilityCard() {
  const [extPolicy, setExtPolicy] = useState("No");
  const [extSA, setExtSA] = useState("");
  const [edu, setEdu] = useState("Post Graduate");
  const [occ, setOcc] = useState("Salaried");
  const [inc, setInc] = useState("0");
  const [age, setAge] = useState("");
  const [ageError, setAgeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [chip, setChip] = useState<{
    text: string;
    bad: boolean;
  } | null>(null);

  const check = async () => {
    if (loading) return;
    const ageVal = parseInt(age) || 0;
    setAgeError(false); 
    if (!ageVal || ageVal < 18 || ageVal > (occ === "Student" ? 25 : 65)) {
      setAgeError(true);
      setChip({
        text: `⚠ Please enter a valid age (18–${occ === "Student" ? 25 : 65}).`,
        bad: true,
      });
      return;
    }
    try {
       if(getTokenExp()){
             localStorage.clear();
             toast.error('Your login is expired!');
            setTimeout(() => {
                window.location.href = import.meta.env.VITE_LOGINURL;
            }, 2000);
            return false
        }
      setLoading(true);
      const payload = {
        education: edu,
        occupation: occ,
        annualIncome: parseInt(inc),
        age: ageVal,
        existingPolicy: extPolicy,
        existingSumAssured: extPolicy === "Yes" ? parseInt(extSA.replace(/[^0-9]/g, "")) || 0 : 0,
      };
      const encryptedResponse = await API.CreateMethod("check-eligible-sa", payload);
      const decryptedResponse = decryptData(encryptedResponse?.data);
      debugger
      if (encryptedResponse?.status==200) {
        const data = decryptedResponse.data;
        if (data?.eligible) {
          setChip({
            text: `✓ ${data.message}`,
            bad: false,
          });
        } else {
          setChip({
            text: `✕ ${data.message}`,
            bad: true,
          });
        }
      } else {
        setChip({
          text: "✕ Something went wrong.",
          bad: true,
        });
      }
    } catch (error) {
      setChip({
        text: "✕ API Error. Please try again.",
        bad: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <label className="cc-label-normal">
        Do you have any existing and/or simultaneously applied for cancer policy with other
        insurers?
      </label>

      <select value={extPolicy} onChange={(e) => setExtPolicy(e.target.value)}>
        <option>No</option>
        <option>Yes</option>
      </select>

      {extPolicy === "Yes" && (
        <>
          <label>Input Sum Assured (with other insurer)</label>

          <input
            placeholder="e.g. 5,00,000"
            value={extSA}
            inputMode="numeric"
            onChange={(e) => {
              const d = e.target.value.replace(/[^0-9]/g, "");

              setExtSA(d ? Number(d).toLocaleString("en-IN") : "");
            }}
          />
        </>
      )}

      <div className="cc-divider" />
      <label>Education</label>
      <select value={edu} onChange={(e) => setEdu(e.target.value)}>
        <option>Post Graduate</option>
        <option>Graduate</option>
        <option>Diploma/Undergraduate</option>
      </select>

      <label>Occupation</label>
      <select value={occ} onChange={(e) => setOcc(e.target.value)}>
        <option>Salaried</option>
        <option>Business Owner</option>
        <option>Self Employed</option>
        <option>Housewife</option>
        <option>Student</option>
        <option>Agriculturist</option>
        <option>Retired</option>
        <option>Others</option>
      </select>

      <label>Annual Income</label>
      <select value={inc} onChange={(e) => setInc(e.target.value)}>
        <option value="0">Less than 3 Lacs</option>
        <option value="3">3 to &lt;5 Lacs</option>
        <option value="5">5 to &lt;7.5 Lacs</option>
        <option value="10">7.5 to &lt;10 Lacs</option>
        <option value="15">10 to &lt;15 Lacs</option>
        <option value="25">≥ 15 Lacs</option>
      </select>

      <label>Age</label>
      <input
        type="number"
        placeholder={`18 – ${occ === "Student" ? 25 : 65}`}
        min={18}
        max={occ === "Student" ? 25 : 65}
        value={age}
        onChange={(e) => {
          if (occ === "Student") {
            if (parseInt(e.target.value) > 25) {
              setAge("25");
              return;
            }
          }
          if (parseInt(e.target.value) > 65) {
            setAge("65");
            return;
          }
          setAge(e.target.value)
        }}
        onBlur={(e) => {
          let v = parseInt(e.target.value)
          if (v < 18) {
            setAge("18");
            return;
          }
        }}
        className={ageError ? "cc-error" : ""}
      />
      {chip && (
        <div
          className="cc-max-sa-chip cc-show"
          style={
            chip.bad
              ? {
                background: "#fef2f2",
                color: "#c62828",
              }
              : undefined
          }
        >
          {chip.text}
        </div>
      )}
      <button className="cc-btn cc-btn-green" onClick={check} disabled={loading}>
        {loading ? "Checking..." : "Check Eligible Sum Assured"}
      </button>
    </>
  );
}
